import React from "react";
import Grid from "@material-ui/core/Grid";
import { ButtonBase, colors } from "@material-ui/core";
import { useHeader } from "../../bill-template02/style";
import { getTotalAmount } from "../../../../utils/utils";
import tafqeet from "../../../../utils/tafqeet";
import { styleFooterNotesAr } from "../../ShareFunctionsPrint";

function TotalsCom(props) {
    const { found, sta, inv, premiApp, locInv } = props;
    const classHeader = useHeader();
    const styeNum = { fontWeight: "bold", textAlign: "center", color: colors.red[500], direction: "ltr" };
    const styeNumN = { fontWeight: "bold", textAlign: "center", color: colors.red[500] };
    const styleSecond = { fontWeight: "bold", textAlign: "right", direction: "ltr", paddingLeft: "0.3rem" };
    const styleNameA = { fontWeight: "bold", textAlign: "right", fontSize: "1rem" };
    const styleCenter = { fontWeight: "bold", textAlign: "center", fontSize: "1rem" };
    const tot_all = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(getTotalAmount(sta.tot));

    const tot_discount = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(sta.tot.discount);

    const tot_vat = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(sta.tot.amountOfVat);

    const tot_before = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(getTotalAmount(sta.tot) - sta.tot?.discount);

    const tot_net = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(sta.tot.tot_net);

    const tot_remain = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(sta.tot.tot_net - sta?.tot?.paid);

    const tot_paid = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(sta?.tot?.paid);
    let agel = sta.tot.tot_net - sta?.tot?.paid;

    let perc_desc = (
        (agel / getTotalAmount(sta.tot) - sta.tot?.discount) *
        100
    ).toFixed(2);
    const styRight = { textAlign: "right", paddingRight: "0.5rem", maxLines: 1, backgroundColor: colors.grey[200] };
    return (
        <Grid item container
            justifyContent="center"
        >
            <Grid
                container
                item xs={12}
                style={{ fontWeight: "bold", border: "solid 1px", fontFamily: "Amiri-Regular", paddingTop: "0.9rem", marginLeft: "0cm", direction: "rtl" }}
            >
                <Grid container item xs={12} >
                    <Grid container item xs={12} style={{ border: "solid 1px", backgroundColor: colors.grey[100] }} >
                        <Grid container item xs={2} style={{ paddingRight: "0.5rem" }} > <div style={styeNumN}>{premiApp.billTemplate === 26 ? tot_paid : tot_net}</div></Grid>
                        <Grid container item xs={1} > <div style={styleNameA}>{"R S"}</div></Grid>
                        <Grid container item xs={9} > <div style={styleNameA}>{premiApp.billTemplate === 26 ? tafqeet(sta?.tot?.paid, "SAR") : tafqeet(sta.tot.tot_net, "SAR")}</div></Grid>
                        <br />
                    </Grid>
                </Grid>
                <Grid container item xs={12}>
                    <Grid item xs={2} className={classHeader.rightHeaderar} >
                        <div style={styeNum}>{tot_all}</div>
                        <div style={styeNum}>{premiApp.billTemplate === 26 ? tot_remain : tot_discount}</div>
                        {premiApp.billTemplate !== 26 &&
                            (
                                <div style={styeNum}>{tot_before}</div>
                            )}
                        <div style={styeNum}>{tot_vat}</div>{" "}
                        {premiApp.billTemplate !== 26 &&
                            (
                                <div style={styeNum}>{tot_net}</div>
                            )}
                        {premiApp.billTemplate === 26 &&
                            (
                                <div style={styeNum}>{tot_paid}</div>
                            )}

                    </Grid>
                    <Grid item xs={7} className={classHeader.leftHeaderen}>
                        <div style={styleSecond}>{premiApp.billTemplate === 26 ? "Total Bussiness" : "Total Excluding VAT"}{"/"}{premiApp.billTemplate === 26 ? "اجمالي الاعمال" : "الاجمالي غير شامل القيمة المضافة"}</div>

                        {premiApp.billTemplate === 26 ?
                            (
                                <div style={styleSecond}> {"("}{perc_desc}{"%"}{")"} {"Retention "}{"/"}{"خصم ضمان الاعمال"}  </div>
                            ) :
                            (
                                <div style={styleSecond}>{"Discount"}{"/"}{"الخصم"}</div>
                            )
                        }

                        {premiApp.billTemplate !== 26 &&
                            (
                                <div style={styleSecond}>{"Total Taxable Amount"}{"/"}{"الاجمالي الخاضع للضريبة"}</div>
                            )}
                        <div style={styleSecond}>{"("} {inv.tax}{"%"}{")"}  {"VAT"}{"/"}{"الضريبة"}</div>{" "}


                        {premiApp.billTemplate !== 26 &&
                            (
                                <div style={styleSecond}>{"Total Amt With Tax"}{"/"}{"الاجمالي النهائي شامل الضريبة"}</div>
                            )}
                        {premiApp.billTemplate === 26 &&
                            (
                                <div style={styleSecond}>{"Total Payable"}{"  /"}{"اجمالي مستحق الدفع "} </div>
                            )}
                    </Grid>
                    <Grid item xs={3} >
                        {(premiApp.billTemplate === 33|| premiApp.billTemplate === 30 ) && found.footer_img != null ?
                            <ButtonBase
                            >
                                {
                                    <img
                                        src={`data:image/jpeg;base64,${found.footer_img}`}
                                        style={{ height: 150, width: 150, margin: 0, padding: 0 }}
                                    // alt={found.nameA}
                                    />
                                }
                            </ButtonBase> : premiApp.billTemplate !== 33 && premiApp.billTemplate !== 26 ?
                                <>
                                    <div style={styleCenter}>{"اجمالي الكميات"}</div>
                                    <div style={styleCenter}>{"Qoantitys"}</div>
                                    <div style={styeNum}>{sta?.info?.reduce(
                                        (sum, item) => Number(sum) + Number(item.val1),
                                        0
                                    )}</div>
                                </> : null
                        }


                    </Grid>
                </Grid>

            </Grid>
            {premiApp.billTemplate === 30 &&
                (
                    <Grid container item xs={12} style={{ paddingTop: "0.3rem" }}>
                        <Grid container item xs={10} style={styRight}>
                            <Grid item container xs={12} style={styleFooterNotesAr}>
                                {inv?.notes}
                            </Grid>
                        </Grid>
                        <Grid container item xs={2} style={{ direction: "ltr", fontWeight: "bold" }}>
                            {"Desscription / "}{"البيان"}
                        </Grid>
                        {locInv?.salesmanName != "" && locInv?.salesmanName != null &&
                            <Grid container item xs={12} style={{ direction: "rtl", fontWeight: "bold" }}>
                                {"المندوب / "}{locInv?.salesmanName}
                            </Grid>
                        }

                    </Grid>
                )}
            {(found.BillNotes != "...." && found.BillNotes != null && found.BillNotes != "" && premiApp.billTemplate !== 33)
                && (
                    <Grid item container xs={12} style={styleFooterNotesAr}>
                        {found.BillNotes}
                    </Grid>
                )}
            {premiApp.billTemplate !== 33 &&
                <Grid
                    container
                    item xs={12}
                    style={{ fontFamily: "Amiri-Regular", paddingTop: "0.9rem", marginLeft: "0cm", direction: "ltr" }}
                >

                    <Grid item xs={5} style={{ textAlign: "left" }}>
                        <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc1_footer_en}</div>
                        <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc2_footer_en}</div>
                        <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc3_footer_en}</div>
                        <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc4_footer_en}</div>
                    </Grid>

                    <Grid item xs={2}></Grid>

                    <Grid
                        item
                        xs={5}
                        className={classHeader.rightHeader}
                        style={{ textAlign: "right" }}
                    >
                        <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}> {found.Disc1_footer_ar}</div>
                        <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc2_footer_ar}</div>
                        <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc3_footer_ar}</div>
                        <div style={{ fontFamily: "Amiri-Regular", fontWeight: "bold" }}>{found.Disc4_footer_ar}</div>
                    </Grid>
                </Grid>
            }

        </Grid>
    );
}
export default TotalsCom;